/* eslint-disable */
import React from 'react'
import { useState, useEffect } from "react";
import { ACCESS_LEVEL, ASSETTYPE, CONTENT_DISTRIBUTION_RESPONSE_TYPE, CONTENT_TYPE, DIGISIGN_LOGTYPE, DOCUMENT_TYPE, FREQUENCY_TYPE, MEDIA_TRANSMISSION, MENUTYPE, MESSAGE_TYPE, MESSAGE_VARIANT, MODULE, OFFER_TYPE, ORIENTATION, PLAYLIST_STATUS, PRIORITY, PRODUCTS, SYNOPSIS_TYPE, THEMES, VODTYPE } from '../../../constant/constant';
import * as API from '../../../API/api'
import { GRID_COL_INDEX_ATTRIBUTE } from '@progress/kendo-react-grid';
import { useTableKeyboardNavigation } from '@progress/kendo-react-data-tools';
import { META_GENDERS } from '../../../../modules/SocialMedia/SocialMediaConstant';

//key name and there enum
var foriegnKey = {
  OttAssetTypeSID: ASSETTYPE,
  MenuType: MENUTYPE,
  OttThemeSID: THEMES,
  moduleID: MODULE,
  frequencyType: FREQUENCY_TYPE,
  Products: PRODUCTS,
  DocumentType: DOCUMENT_TYPE,
  Status: PLAYLIST_STATUS,
  content_type: CONTENT_TYPE,
  orientation: ORIENTATION,
  accessLevel: ACCESS_LEVEL,
  MessageType: MESSAGE_TYPE,
  MessageVariant: MESSAGE_VARIANT,
  logType: DIGISIGN_LOGTYPE,
  genders: META_GENDERS,
  Type: SYNOPSIS_TYPE,
  ResponseType: CONTENT_DISTRIBUTION_RESPONSE_TYPE,
  Transmission: MEDIA_TRANSMISSION,
  VODType: VODTYPE,
  OfferType: OFFER_TYPE,
  Priority: PRIORITY
}

export const EnumCell = (props) => {

  const field = props.field || "";
  const fk_entityName = props.fk_entityName;
  const value = props.dataItem != undefined ? props.dataItem[field] : 1;
  const [displayValue, setdisplayValue] = useState("");

  useEffect(() => {
    loaddata();
  }, [props.dataItem])


  async function loaddata() {
    //TO SHOW Description,Name etc.. if only _id is saving in db
    if (!foriegnKey[field] && fk_entityName) {
      let masterRes = await API.getDataLookup(fk_entityName, { sort: { SID: 1 }, query: ['Archive', '=', false] });
      setdisplayValue(masterRes.data.find((x) => x._id == props.dataItem[field])[props?.format])
    } else if (!foriegnKey[field]) {
      let entityName = field.toLowerCase();
      let masterRes = await API.getDataLookup(entityName, { sort: { SID: 1 }, query: ['Archive', '=', false] });
      setdisplayValue(masterRes.data.find((x) => x._id == props.dataItem[field])[props?.format])
    } else {
      let arrayENUM = Object.keys(foriegnKey[field]).map((key) => { return { ID: foriegnKey[field][key], Description: key } })
      let filter = arrayENUM?.find((x) => x?.ID == value);
      setdisplayValue(filter?.Description ?? '');
    }

  }

  return <td
    colSpan={props.colSpan}
    role={"gridcell"}
    aria-colindex={props.ariaColumnIndex}
    aria-selected={props.isSelected}
    {...{
      [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
    }}
    {...useTableKeyboardNavigation(props.id)}
    // style={{textAlign : 'center'}}
    style={props.style}
  >
    {displayValue}
  </td>;
};

export const SIDEnumCell = (props) => {

  const { id, colSpan, ariaColumnIndex, isSelected, style, columnIndex, dataItem, field = "", fk_entityName, fk_field } = props;
  const value = (dataItem && field) ? dataItem[field] : null;

  if (!value) return <td></td>;

  const [displayValue, setdisplayValue] = useState("");

  useEffect(() => {
    loaddata();
  }, [dataItem])


  const loaddata = async () => {
    if (!fk_entityName) return;
    let res = await API.getDataLookup(fk_entityName, { query: ['SID', '=', value] });
    setdisplayValue(res?.data?.length > 0 ? res?.data[0][fk_field] : '');
  }

  return <td
    colSpan={colSpan}
    role={"gridcell"}
    aria-colindex={ariaColumnIndex}
    aria-selected={isSelected}
    {...{
      [GRID_COL_INDEX_ATTRIBUTE]: columnIndex,
    }}
    {...useTableKeyboardNavigation(id)}
    // style={{textAlign : 'center'}}
    style={style}
  >
    {displayValue}
  </td>;

}